module.exports = __webpack_public_path__ + "media/application/images/demo/wall2_m-ec7b5ade4db751f9f5aed399ea4f47b7.jpg";